import { sanitizeObject } from "../helpers/sanitizers";

export default (data) => ({...data, reviewData: data.reviewData.map(item => sanitizeObject(item))});

// export default (data) => {
//     console.log(data, "777");
//     return data;
// };

